export type AdminNavItem = {
	to: string;
	label: string;
};

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
	{ to: "/", label: "Séries" },
	{ to: "/users", label: "Utilisateurs" },
	{ to: "/stats", label: "Statistiques" },
	{ to: "/settings", label: "Paramètres" },
];
